import { Component, computed, effect, ElementRef, input, output } from '@angular/core';
import { KopConfigService } from '../../core/kop-config.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { KopModulesService } from '../../modules/kop-modules.service';
import { Alarm, cKC_Alarm } from '@wasm/KopWeb';
import { eraseFromWasmVector, wasmMapToRecord, wasmVectorFindIndex, wasmVectorToArray } from '../../utils/wasmVector';
import { AnalogIn, DigitalIn, ModuleAlarm, RangedKanaal, RangedKanaalInput } from '../PropTypes';
import { KanaalService } from '../../kanaal/kanaal.service';
import { BaseListComponent } from '../../keynav/base-list/base-list.component';
import { FocusManagerService } from '../../keynav/focus-manager.service';
import { BaseElementComponent } from '../../keynav/base-element/base-element.component';

@Component({
  selector: 'alarm-editor',
  templateUrl: './alarm-editor.component.html',
  styles: ``
})
export class AlarmEditorComponent extends BaseElementComponent {

  constructor(public kopConfigService: KopConfigService, public jsBridgeService: JSBridgeService,
    public kopModulesService: KopModulesService, public kanaalService: KanaalService,elementRef: ElementRef<HTMLElement>, focusManager: FocusManagerService) {

    super(elementRef,focusManager);
    this.keyProperty = "alarm-editor";
    effect(() => {
      let al = this.initialValue();
      if (al != undefined) {
        this.editVal = { ...al };
        return;
      }
      let alarm = this.alarm();
      if (alarm != undefined) {
        this.editVal = this.kopConfigService.kcAlarm2Model(alarm.index, alarm)!;
      }
    })
  }


  public alarm = input<cKC_Alarm>()
  public isNew = input<boolean>(false);
  public editOnly = input<boolean>(false);
  public valueChanged = output<ModuleAlarm>();
  

  public newMeta: Alarm | undefined = undefined;
  public initialValue = input<ModuleAlarm>();
  public onlyDesc = input<boolean>(false);

  public text() {
    let typeIndex = 0;
    let kanaal = 0;
    let iv = this.initialValue();
    if (iv != undefined) {
      typeIndex = iv.typeIndex;
      kanaal = iv.kanaal;
    } else {
      let a = this.alarm();
      if (a != undefined) {
        typeIndex = a.typeIndex;
        kanaal = a.kanaal;
      }
    }
    let meta = this.meta();
    let jsBridge = this.jsBridgeService.getBridgeSync();

    if (meta != undefined) {
      let vrijText = this.kopConfigService.getTextForAlarm(this.meta())
      let alarmTypes = wasmVectorToArray(jsBridge.getAlarmTypes());
      let type = alarmTypes.find(at => at.index == typeIndex);
      if (type == undefined) {
        return meta.omschr;
      }
      let inv = this.kanaalService.getInvTab(kanaal, DigitalIn);
      if (this.onlyDesc()) {
        return vrijText;
      }
      return `${vrijText} - ${type.omschr} - ${kanaal}${inv ? '!' : ''}`;
    }
    return "";
  }


  public meta = computed(() => {
    let a = this.alarm();
    if (a != undefined) {
      return this.kopConfigService.getAlarmMeta(a);
    }
    let iv = this.initialValue();
    if (iv != undefined) {
      return this.kopConfigService.getAlarmMeta(iv);
    }
    return this.newMeta;
  });

  public assignment = computed(() => {
    let meta = this.meta();
    let afd = this.kopConfigService.selectedAfd();
    let a = this.alarm();
    if (meta != undefined && afd != undefined && a != undefined) {
      return this.kanaalService.buildAssignementInfo('alarm', afd?.afdeling(), meta, a);
    }

  });


  public alarmsOptions = computed(() => {
    let metas = this.kopConfigService.getAlarmsMeta();
    let selectedModule = this.kopModulesService.selectedAfdModule();
    if (selectedModule != undefined) {
      metas = metas.filter(m => {
        if (selectedModule.meta.alarms != undefined) {
          return selectedModule.meta.alarms.indexOf(m.index) >= 0
        }
        return false;
      });
    }
    return metas;
  });

  labelFn() {
    let ret = (meta: any) => {
      let ret2 = this.kopConfigService.getTextForAlarm(meta);
      return ret2;
    }
    return ret;
  }

  onNew(a: any) {
    let alarm = a as Alarm;
    this.newMeta = alarm;
    if (alarm.vrijetext == 0) {
      this.editVal = {
        index: alarm.index,
        kanaal: 0,
        typeIndex: 0,
        inverted: false
      }
      this.toggleType0();
    } else {
      this.editVal = {
        index: alarm.index,
        kanaal: 0,
        typeIndex: this.types()[0].index,
        inverted: false
      }
      this.open();

    }
  }

  alreadySelectedFN() {
    let tmAlarms = this.kopConfigService.selectedAfd()?.afdeling().alarms;
    if (tmAlarms != undefined) {
      // let alarms = wasmVectorToArray(tmAlarms);
      let ret = (idx: number) => {
        return wasmVectorFindIndex(tmAlarms, a => a.index == idx) != -1;
        // return alarms.find(a => a.index == idx) != undefined;
      }
      return ret;
    }
    return (idx: number) => false;
  }

  public types = computed(() => {
    let jsBridge = this.jsBridgeService.getBridgeSync();
    let meta = this.meta();
    let alarmTypes = wasmVectorToArray(jsBridge.getAlarmTypes()).filter(at => at.groep == meta?.groep);
    return alarmTypes.map(at => {
      return {
        index: at.index,
        text: at.omschr
      }
    });
  });


  public editVal: ModuleAlarm = {
    index: 0,
    kanaal: 0,
    typeIndex: 0,
    inverted: false
  };

  public ioType = DigitalIn;


  private toggleType0() {
    this.kopConfigService.applyAfdUpdate(afd => {
      this.kanaalService.setInvTab(this.editVal.kanaal, DigitalIn, this.editVal.inverted, 1);
      let alarms = afd?.afdeling().alarms;
      if (alarms != undefined) {
        let idx = wasmVectorToArray(alarms).findIndex(al => al.index == this.editVal.index);
        if (idx >= 0) {
          eraseFromWasmVector(alarms, this.editVal.index);
        } else {
          let wasm = this.jsBridgeService.wasmModule!;
          let alarmRef = new wasm.cKC_Alarm();
          alarmRef.index = this.editVal.index;
          alarmRef.kanaal = this.editVal.kanaal;
          alarmRef.typeIndex = this.editVal.typeIndex;
          alarms.push_back(alarmRef);

        }

        console.log("Found idx", idx);

      }
      return afd;
    });

  }

  onEdit() {
    // let alarm = this.alarm();
    // if (alarm == undefined) return;
    // this.editVal = this.kopConfigService.kcAlarm2Model(alarm);
    if (this.editVal.typeIndex == 0) {
      this.toggleType0();
    } else {
      this.open();
    }
  }


  onKanaalChange(event: RangedKanaalInput) {
    this.editVal.kanaal = event.start;
    this.editVal.inverted = event.inverted == true;
  }
  onDelete() {
    this.close();
    this.kopConfigService.eraseAlarm(this.editVal.index);
  }
  onSave() {
    this.close();
    if (this.editOnly()) {
      this.valueChanged.emit(this.editVal);
      return;
    } 
    this.kopConfigService.upsertAlarm(this.editVal);
  }
}
